/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'

import Panel from '../structure/Panel'
import SeparatorWrapper from './SeparatorWrapper'

export const TooltipContent = ({
  ref,
  children,
  noPadding,
  open,
  onClose,
  left,
  bottom,
  top,
  padding,
  autoSize,
  ...props
}) => {
  if (!open) return false

  const style = css`
    left: ${left || 0};
    ${top && `top: ${top}`};
    ${bottom && `bottom: ${bottom}`};
    ${padding && `padding: ${padding}`};
    position: absolute;
    width: ${autoSize ? 'auto' : 'max-content'};
    z-index: 10000;
  `

  return (
    <div css={style} ref={ref}>
      <Panel noPadding={noPadding} smallPadding noMargin {...props}>
        <SeparatorWrapper weight={1}>{children}</SeparatorWrapper>
      </Panel>
    </div>
  )
}

const Tooltip = ({ disabled, actionContent, children, disableLazyClose, ...props }) => {
  const style = css`
    position: relative;
  `

  let timeoutId = null
  const [open, setOpen] = React.useState(false)
  const onOpen = () => {
    clearTimeout(timeoutId)
    setOpen(true)
  }
  const onClose = () => {
    timeoutId = setTimeout(() => setOpen(false), !disableLazyClose ? 300 : 0)
  }

  if (!!disabled || !children) return actionContent

  return (
    <div css={style} onMouseEnter={onOpen} onMouseLeave={onClose}>
      {actionContent}
      <TooltipContent open={open} onClose={onClose} children={children} {...props} />
    </div>
  )
}

export default Tooltip
